import { useApiQuery } from '@/modules/common';
import { PrinterType } from '@/modules/common/types';
import { useModelAttributes } from '@/modules/models';

export function useGcrFormOptions() {
  const { data: optionsData } = useModelAttributes();

  const { data: printers, isFetching: isFetchingPrinters } = useApiQuery<
    PrinterType[]
  >('/printers', {
    queryKey: ['printers'],
    initialData: [],
  });

  return {
    isFetchingPrinters,
    printers,
    optionsData: {
      printers,
      ...optionsData,
    },
  } as const;
}
